import React, { Component } from "react";
import CSSModules from "react-css-modules";
import shouldUpdate from "recompose/shouldUpdate";
import TimeCell from "../TableCells/Time/TimeCell_component";
import TagsCell from "../TableCells/Tags/TagsCell_component";
import classnames from "classnames";
import styles from "./styles.scss";

const TableBody = props => {
  console.log("Rerendering table body: ", props);
  const { rows, cols, questionId, hasMoreData, viewMoreStr, getData } = props;
  var datacnt = "data_" + questionId;
  return (
    <div styleName="qualTblScrollCnt" id={datacnt}>
      <table styleName="QualTableBody">{buildTableBody(rows, cols)}</table>
      {getViewMoreButton(hasMoreData, viewMoreStr, getData)}
    </div>
  );
};

const openGallery = (modalId, mediaType) => {
  TA.QuestionLayout.openGallery(modalId, mediaType); // eslint-disable-line
};

const getViewMoreButton = (hasMoreData, viewMoreStr, getData) => {
  if (hasMoreData === true) {
    return (
      <div
        id="linkToolbar"
        name="linkToolbar"
        styleName="view-more-btn"
        className="viewTypeToolbar f_left visibleLinks"
      >
        <a onClick={getData}>{viewMoreStr}</a>
      </div>
    );
  }
  return <div />;
};

const buildTableBody = (rows, cols) => {
  return (
    <tbody>
      {rows.map(function(item, idx) {
        const cells = cols.map(function(colData, index) {
          //var cmplxClasses = cellClasses + ' ' + colData.key;
          const cellClasses = classnames({
            [styles.cell]: true,
            [styles.odd]: idx % 2 === 0,
            [styles.even]: idx % 2 !== 0,
            [styles[colData.key]]: true
          });
          const cellDivClasses = classnames({
            [styles.content]: true,
            [styles[colData.key]]: true
          });
          let cellContent;
          if (colData.key == "timestamp") {
            cellContent = <TimeCell timestamp={item[colData.key]} />;
            //cellContent = item[colData.key].date + " " + item[colData.key].time;
          } else if (colData.key == "tags") {
            //cellContent = item[colData.key].mainTag + " (+" + item[colData.key].tagsNum + ")";
            cellContent = <TagsCell tags={item[colData.key]} />;
          } else if (colData.key == "media") {
            cellContent = item[colData.key].map(function(media) {
              var modalId = new Date().getTime() + "" + idx + "" + index;
              if (media.type == "IMAGE") {
                return (
                  <span key={media.name}>
                    <a
                      onClick={openGallery.bind(this, modalId)}
                      href="javascript:void(0)"
                    >
                      {media.name}
                    </a>
                    <div
                      className="remodal image-gallery-image-full-qual"
                      data-remodal-id={modalId}
                    >
                      <i
                        data-remodal-action="close"
                        className="fa fa-circle modal-close"
                      />
                      <i
                        data-remodal-action="close"
                        className="fa fa-times modal-close"
                      />
                      <img src={media.url} />
                    </div>
                  </span>
                );
              } else {
                return (
                  <span key={media.name}>
                    <a
                      onClick={() => {
                        openGallery(modalId, media.type);
                      }}
                      href="javascript:void(0)"
                    >
                      {media.name}
                    </a>
                    <div
                      className="remodal image-gallery-image-full-qual"
                      data-remodal-id={modalId}
                      data-remodal-video-qual="true"
                      data-video-url={media.url}
                    >
                      <i
                        data-remodal-action="close"
                        className="fa fa-circle modal-close"
                      />
                      <i
                        data-remodal-action="close"
                        className="fa fa-times modal-close"
                      />
                      <div id={modalId}>
                        <iframe
                          className="mediaPlayerFrame"
                          src={media.url}
                        />
                      </div>
                    </div>
                  </span>
                );
              }
            });
          } else if (
            colData.key == "likes" &&
            parseInt(item[colData.key]) == 0
          ) {
            cellContent = "";
          } else if (
            colData.key == "sentiment" &&
            item[colData.key] == "none"
          ) {
            cellContent = "";
          } else {
            var txt = item[colData.key] + "";
            var regex = /(<([^>]+)>)/gi;
            var result = txt.replace(regex, " ");
            cellContent = result;
          }
          //console.log('Cell id: ', colData.key);

          return (
            <td className={cellClasses} key={colData.key}>
              <div className={cellDivClasses}>{cellContent}</div>
            </td>
          );
        });

        //console.log('RowKey: ', item.rowId);

        return (
          <tr styleName="row" key={item.rowId}>
            {cells}
          </tr>
        );
      })}
    </tbody>
  );
};

const propsCheck = (props, nextProps) => {
  const { rows, cols, hasMoreData } = props;

  return (
    JSON.stringify(rows) !== JSON.stringify(nextProps.rows) ||
    JSON.stringify(cols) !== JSON.stringify(nextProps.cols) ||
    hasMoreData !== nextProps.hasMoreData
  );
};

export default shouldUpdate(propsCheck)(CSSModules(TableBody, styles));



// WEBPACK FOOTER //
// ./components/qual/Table/TableBody/TableBody_component.js